import { Link } from 'react-router'
import { LuArrowRight, LuCheck } from 'react-icons/lu'
import { ROUTES } from '@/constants/routes'
import { Reveal } from '@/components/ui/Reveal'
import { SectionHeader } from '@/components/ui/SectionHeader'
import { SitePhoto } from '@/components/ui/SitePhoto'
import { primaryLink } from '@/components/ui/linkStyles'
import { kandakeHeadshot } from '@/assets/siteMedia'
import { supports } from '@/data/consultations'

export const ConsultationsOverview = () => (
  <section className="bg-base-50 py-16 sm:py-20 lg:py-24">
    <div className="mx-auto max-w-6xl px-6">
      <div className="grid items-start gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16">
        <Reveal>
          <div className="mx-auto w-full max-w-md overflow-hidden rounded-3xl border border-base-200 bg-white p-2 shadow-[0_16px_48px_rgba(26,70,26,0.07)] sm:p-3">
            <SitePhoto
              src={kandakeHeadshot}
              alt="Kandake Makonnen, medical herbalist"
              aspect="aspect-[4/5]"
              className="rounded-2xl"
            />
          </div>
        </Reveal>

        <div>
          <SectionHeader title="Rooted in" accent="whole-person care" className="mb-8" />
          <Reveal>
            <div className="space-y-4 text-base leading-7 text-base-600">
              <p>
                Each consultation is designed to go beyond the surface symptom by exploring your
                health history, lifestyle, emotional wellbeing, and the interconnected systems of
                your body to identify the true root of imbalance.
              </p>
              <p>
                Drawing on over 20 years of clinical practice, traditional African and Caribbean
                healing knowledge, and a BSc in Medical Herbalism, Kandake creates a personalised
                protocol using herbs, nutrition, and lifestyle practices tailored specifically to
                you.
              </p>
            </div>
          </Reveal>

          <Reveal>
            <div className="mt-8 rounded-3xl border border-green-100 bg-green-50 p-6 sm:p-8">
              <h3 className="mb-5 font-display text-xl text-green-900">
                Conditions &amp; areas of support
              </h3>
              <ul className="grid gap-x-6 gap-y-3 sm:grid-cols-2">
                {supports.map((s) => (
                  <li key={s} className="flex items-center gap-3 text-sm text-base-700">
                    <span
                      aria-hidden="true"
                      className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-white text-green-700"
                    >
                      <LuCheck className="h-3 w-3" />
                    </span>
                    {s}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>

          <Reveal>
            <div className="mt-8">
              <Link to={`${ROUTES.CONTACT}?service=herbal-consultation`} className={primaryLink}>
                Book a Consultation
                <LuArrowRight aria-hidden="true" className="h-4 w-4 shrink-0" />
              </Link>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
)
